import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import menuIntelImg from "../../assets/images/global-splash-mi-card.png";
import conceptLockerImg from "../../assets/images/global-splash-cl-card.png";
import marketLaunchImg from "../../assets/images/global-splash-ml-card.png";
import innovaImg from "../../assets/images/global-splash-innova-card.png";
import { NavLink } from "react-router-dom";

export default function GlobalSplashNavigation() {
  let CONCEPT_LOCKER_HOME_LINK = "https://conceptlocker.miron.services";
  let MARKET_LAUNCH_HOME_LINK = "https://marketlaunch.miron.services";
  if (window.location.hostname === "flavoriq.global") {
    CONCEPT_LOCKER_HOME_LINK = "https://conceptlocker.flavoriq.global";
    MARKET_LAUNCH_HOME_LINK = "https://marketlaunch.flavoriq.global";
  }

  return (
    <>
      <div className="global-splash-cards-wrapper">
        <div className="splash-cards">
          <Typography
            gutterBottom
            variant="h3"
            component="div"
            style={{ flexBasis: "100%", marginLeft: "25px" }}
          >
            <em>GRIFFITH FOODS INNOVATIONS</em>
          </Typography>
          <NavLink
            to={CONCEPT_LOCKER_HOME_LINK}
            style={{ textDecoration: "none" }}
          >
            <Card sx={{ mb: 3, mt: 1 }} className="splash-card">
              <CardActionArea className="splash-card--action-area">
                <div className="overlay-wrapper">
                <CardMedia
                  component="img"
                  image={conceptLockerImg}
                  alt="browse"
                  sx={{
                    ml: "auto",
                    mr: "auto",
                  }}
                />
                <Typography
                    component="div"
                    style={{     
                      position: "absolute",
                      right: 0,
                      top: 0,
                      background: "#ff9300",
                      color: "#fff",
                      fontSize: "16px",
                      lineHeight: "30px",
                      width: "50%",
                      letterSpacing: "1px",
                      fontFamily: "Source Sans Pro,sans-serif",
                      fontWeight: "600"
                    }}
                  >IDEATIONS</Typography>
                  </div>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h3"
                    component="div"
                    style={{ color: "#ff9300", fontSize: "20px" }}
                  >
                    <em>Culinary Concept Locker</em>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Griffith Foods culinary staff turn ingredients into culinary
                    inspiration, based on real-life insights.
                  </Typography>
                  <KeyboardArrowDownIcon
                    color="primary"
                    aria-label="arrow"
                    sx={{
                      mt: 1,
                      mb: 1,
                      fontSize: "2.4rem",
                      fill: "#ff9300",
                      "&:hover": { fill: "#8dc63f" },
                    }}
                  />
                </CardContent>
              </CardActionArea>
            </Card>
          </NavLink>

          <NavLink
            to={MARKET_LAUNCH_HOME_LINK}
            style={{ textDecoration: "none" }}
          >
            <Card sx={{ mb: 3, mt: 1 }} className="splash-card">            
              <CardActionArea className="splash-card--action-area">
              <div className="overlay-wrapper">
                <CardMedia
                  component="img"
                  image={marketLaunchImg}
                  alt="browse"
                  sx={{
                    ml: "auto",
                    mr: "auto",
                  }}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h3"
                    component="div"
                    style={{ color: "#930a93", fontSize: "20px" }}
                  >
                    <em>Market Launch</em>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Explore Griffith Foods ingredients that have made it into
                    products, and onto menus, and store shelves around the
                    globe.
                  </Typography>
                  <KeyboardArrowDownIcon
                    htmlColor="#930a93"
                    aria-label="arrow"
                    sx={{
                      mt: 1,
                      mb: 1,
                      fontSize: "2.4rem",
                      "&:hover": { fill: "#8dc63f" },
                    }}
                  />
                </CardContent>
                <Typography
                    component="div"
                    style={{     
                      position: "absolute",
                      right: 0,
                      top: 0,
                      background: "#930a93",
                      color: "#fff",
                      fontSize: "16px",
                      lineHeight: "30px",
                      width: "50%",
                      letterSpacing: "1px",
                      fontFamily: "Source Sans Pro,sans-serif",
                      fontWeight: "600"
                    }}
                  >LAUNCHED</Typography>
                </div>
              </CardActionArea>
            </Card>
          </NavLink>
        </div>

        <div className="splash-cards">
          <Typography
            gutterBottom
            variant="h3"
            component="div"
            style={{ flexBasis: "100%", marginLeft: "25px" }}
          >
            <em>INDUSTRY INNOVATIONS</em>
          </Typography>

          <NavLink to="/dashboard" style={{ textDecoration: "none" }}>
            <Card sx={{ mb: 3, mt: 1 }} className="splash-card">
              <CardActionArea className="splash-card--action-area">
              <div className="overlay-wrapper">
                 <CardMedia
                  component="img"
                  image={menuIntelImg}
                  alt="browse"
                  sx={{
                    ml: "auto",
                    mr: "auto",
                  }}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h3"
                    component="div"
                    style={{ color: "#007044", fontSize: "20px" }}
                  >
                    <em>Menu Intelligence</em>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    See what's trending on menus with chain restaurant and
                    foodservice customers in your market and around the world.
                  </Typography>
                  <KeyboardArrowDownIcon
                    color="primary"
                    aria-label="arrow"
                    sx={{
                      mt: 1,
                      mb: 1,
                      fontSize: "2.4rem",
                      "&:hover": { fill: "#8dc63f" },
                    }}
                  />
                </CardContent>
                <Typography
                    component="div"
                    style={{     
                      position: "absolute",
                      right: 0,
                      top: 0,
                      background: "#007044",
                      color: "#fff",
                      fontSize: "16px",
                      lineHeight: "30px",
                      width: "100%",
                      letterSpacing: "1px",
                      fontFamily: "Source Sans Pro,sans-serif",
                      fontWeight: "600",
                      textAlign: "center"
                    }}
                  >QSR/FOODSERVICE LAUNCHES</Typography>
                </div>
              </CardActionArea>
            </Card>
          </NavLink>

          <NavLink
            to="https://innovamarketinsights360.com/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Card sx={{ mb: 3, mt: 1 }} className="splash-card">
              <CardActionArea className="splash-card--action-area">
              <div className="overlay-wrapper">
                <CardMedia
                  component="img"
                  image={innovaImg}
                  alt="browse"
                  sx={{
                    ml: "auto",
                    mr: "auto",
                  }}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h3"
                    component="div"
                    style={{ color: "#00aaf0", fontSize: "20px" }}
                  >
                    <em>Innova Market Insights</em>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Innova Market Insights&rsquo; Global New Products Database provides market
                    intelligence across Retail, Protein, and Food Manufacturer
                    industries to help guide marketing strategies and business
                    decisions.
                  </Typography>
                  <KeyboardArrowDownIcon
                    color="primary"
                    aria-label="arrow"
                    sx={{
                      mt: 1,
                      mb: 1,
                      fontSize: "2.4rem",
                      fill: "#00aaf0",
                      "&:hover": { fill: "#8dc63f" },
                    }}
                  />
                </CardContent>
                <Typography
                    component="div"
                    style={{     
                      position: "absolute",
                      right: 0,
                      top: 0,
                      background: "#00aaf0",
                      color: "#fff",
                      fontSize: "16px",
                      lineHeight: "30px",
                      width: "100%",
                      letterSpacing: "1px",
                      fontFamily: "Source Sans Pro,sans-serif",
                      fontWeight: "600",
                      textAlign: "center"
                    }}
                  >PROTEIN + RETAIL LAUNCHES</Typography>
                </div>
              </CardActionArea>
            </Card>
          </NavLink>
        </div>
      </div>
    </>
  );
}
